import Link from 'next/link';
import React from 'react';

const FeaturePanel = ({ headline, description, children, link = '#' }) => (
  <li className="mb-4 w-full bg-neutral-100 rounded-lg hover:bg-neutral-200">
    <Link href={link} aria-label={link} className="block py-4">
      <div className="flex gap-4 px-4">
        <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-black">
          {children}
        </div>
        <div className="flex flex-col gap-1 min-w-0">
          <div className="font-bold text-black">{headline}</div>
          <div className="text-black">{description}</div>
        </div>
      </div>
    </Link>
  </li>
);

export default FeaturePanel;
